import { LayersIcon, PlusCircle, Save } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Card, Container, Row, Col, Form, Button, Modal, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router";
import layerServices from "services/layerServices";
import { formatSlot } from "utils/helper";
import { imageUrl } from "utils/helper";
import { showSuccessAlert } from "utils/swalAlert";


const themeLight = "#17AAA7"
const themeColor = "#17AAA7"
const themeDark = "#17AAA7"
function Layers() {

    const { machineId } = useParams()
    const [numberOfLayers, setNumberOfLayers] = useState("");
    const [showLayers, setShowLayers] = useState(false);
    const [showVendingMachine, setShowVendingMachine] = useState(true);
    const [selectedLayer, setSelectedLayer] = useState(null);
    const [machineData,setMachineData]=useState()

    const [productFiles, setProductFiles] = useState({});

    const navigate = useNavigate()


    // @custom hooks 
    const { createLayer, getMachineLayer, uploadImage, createProduct } = layerServices()
    const [layers, setLayers] = useState([]);


    // @get Layers api call 

    useEffect(() => {
        getMachineLayer(machineId).then((res) => {
            console.log(res)
            if (res.success) {
                setMachineData(res.data.machine)
                setLayers(res.data.layers)
                setShowVendingMachine(true)
            } else {
                setShowVendingMachine(false)
            }
        }).catch(err => console.log(err))
    }, [])


    const handleEditLayer = (layer) => {
        navigate(`/admin/machines/layers/${machineId}/${layer.id}`, {
            state: { layer: layer }
        })
        console.log(layer)
        setSelectedLayer(layer);
        // setShowModal(true);
    };

    const handleCreateLayers = () => {
        const layerCount = parseInt(numberOfLayers);
        if (layerCount > 0) {
            const newLayers = Array.from({ length: layerCount }, (_, index) => ({
                id: index + 1,
                name: `Layer ${index + 1}`,
                coils: 0,
                capacity: 0
            }));
            setLayers(newLayers);
            setShowLayers(true);
        }
    };

    const updateLayerCoils = (layerId, coils) => {
        setLayers(prev => prev.map(layer =>
            layer.id === layerId ? { ...layer, coils: parseInt(coils) || 0 } : layer
        ));
    };

    const updateLayerCapacity = (layerId, capacity) => {
        setLayers(prev => prev.map(layer =>
            layer.id === layerId ? { ...layer, capacity: parseInt(capacity) || 0 } : layer
        ));
    };

    const handleFinalCreate = async () => {
        console.log("Layers configuration:", layers);
        const payload = {
            machineId: machineId,
            layers: layers
        }
    
        const res = await createLayer(payload)
        console.log(res)
        if (res.success) {
            showSuccessAlert("Machine Layers Configured")
            setLayers(res.data.layers)
            setShowVendingMachine(true);
        }

    };

    return (
        <Container fluid>
            <Row>
                <Col md="12">
                    <Card className="strpied-tabled-with-hover">
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <div>
                             
                                {machineData && (
                                    <div className="d-flex flex-wrap gap-2 align-items-center">
                                        <div className="d-flex align-items-center gap-2">
                                            <strong>Name:</strong>
                                            <span className="badge bg-primary">{machineData.name}</span>
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <strong>ID:</strong>
                                            <span className="badge bg-secondary">{machineData.machineId}</span>
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <strong>Location:</strong>
                                            <span className="badge bg-info">{machineData.location}</span>
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <strong>Status:</strong>
                                            <span className={`badge ${machineData.status === 'active' ? 'bg-success' : machineData.status === 'inactive' ? 'bg-danger' : 'bg-warning'}`}>
                                                {machineData.status}
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Card.Header>
                
                        <Card.Body className="table-full-width table-responsive px-0">
                            {showVendingMachine ? (
                                <div className="p-4">
                                    <div style={{ border: '3px solid #333', borderRadius: '10px', padding: '20px', backgroundColor: '#f8f9fa', maxWidth: '800px', margin: '0 auto' }}>
                                        {layers.map((layer) => (
                                            <div key={layer.id} style={{ marginBottom: '15px', border: '1px solid #ddd', borderRadius: '5px', padding: '10px', backgroundColor: 'white' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                                    <div style={{ fontWeight: 'bold', textAlign: 'center', flex: 1 }}>Layer {layer.id}</div>
                                                    <Button size="sm" variant="outline-primary" onClick={() => handleEditLayer(layer)}>Edit</Button>
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'center', gap: '5px', flexWrap: 'wrap' }}>
                                                    {Array.from({ length: layer.coils }, (_, coilIndex) => {
                                                        const slot = layer.slots?.[coilIndex];
                                                        const hasProduct = slot?.productId;

                                                        return (
                                                            <div key={coilIndex} style={{ textAlign: 'center' }}>
                                                                <div style={{
                                                                    width: '60px',
                                                                    height: '80px',
                                                                    border: `2px solid ${hasProduct ? '#28a745' : '#007bff'}`,
                                                                    borderRadius: '5px',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    fontSize: '8px',
                                                                    backgroundColor: hasProduct ? '#d4edda' : '#e3f2fd',
                                                                    marginBottom: '5px',
                                                                    padding: '2px'
                                                                }}>
                                                                    {hasProduct ? (
                                                                        <>
                                                                            <img
                                                                                src={imageUrl(slot.productId.image)}
                                                                                alt={slot.productId.name}
                                                                                style={{ width: '30px', height: '30px', objectFit: 'cover', borderRadius: '3px', marginBottom: '2px' }}
                                                                            />
                                                                            <div style={{ fontSize: '7px', fontWeight: 'bold', textAlign: 'center', lineHeight: '1' }}>
                                                                                {slot.productId.name.substring(0, 8)}...
                                                                            </div>
                                                                            <div style={{ fontSize: '6px', color: '#28a745' }}>LRD{slot.productId.finalPrice}</div>
                                                                            <div style={{ fontSize: '6px', color: '#666' }}>Stock: {slot.currentStock || 0}</div>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <div style={{ fontSize: '10px', marginBottom: '5px' }}>Cap: {layer.capacity}</div>
                                                                            <div style={{ fontSize: '8px', color: '#666' }}>Empty</div>
                                                                        </>
                                                                    )}
                                                                </div>
                                                                <div style={{ fontSize: '8px' }}>
                                                                    {/* [{layer.id - 1},{coilIndex + 1}] */}
                                                                    {formatSlot(layer.id - 1 ,coilIndex + 1)}
   
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    {/* <Button
                                        variant="secondary"
                                        onClick={() => setShowVendingMachine(false)}
                                        className="mt-3"
                                    >
                                        Back to Configuration
                                    </Button> */}
                                </div>
                            ) : !showLayers ? (
                                <div className="p-5 text-center">
                                    <div className="mb-4">
                                        <div className="mx-auto mb-3" style={{
                                            width: '80px',
                                            height: '80px',
                                            borderRadius: '50%',
                                            backgroundColor: themeLight,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <LayersIcon size={40} style={{ color: themeColor }} />
                                        </div>
                                        <h4 className="fw-bold" style={{ color: themeDark }}>Configure Your Vending Machine</h4>
                                        <p className="text-muted">Start by specifying the number of layers</p>
                                    </div>

                                    <Card className="border-0 shadow-sm mx-auto" style={{ maxWidth: '400px' }}>
                                        <Card.Body>
                                            <Form.Group className="mb-4">
                                                <Form.Label className="fw-bold" style={{ color: themeDark }}>
                                                    Number of Layers
                                                </Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={numberOfLayers}
                                                    onChange={(e) => setNumberOfLayers(e.target.value)}
                                                    placeholder="Enter number of layers"
                                                    min="1"
                                                    max="20"
                                                    className="py-2"
                                                    style={{
                                                        borderColor: themeColor,
                                                        borderWidth: '2px'
                                                    }}
                                                />
                                                <Form.Text className="text-muted">
                                                    Maximum 20 layers recommended for optimal performance
                                                </Form.Text>
                                            </Form.Group>
                                            <Button
                                                variant="primary"
                                                onClick={handleCreateLayers}
                                                disabled={!numberOfLayers}
                                                className="w-100 py-2 d-flex align-items-center justify-content-center"
                                                style={{
                                                    backgroundColor: themeColor,
                                                    borderColor: themeColor
                                                }}
                                            >
                                                <PlusCircle size={18} className="me-2" />
                                                Create Layers
                                            </Button>
                                        </Card.Body>
                                    </Card>
                                </div>
                            ) : (
                                <div className="p-4">
                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                        <h5 className="fw-bold" style={{ color: themeDark }}>
                                            Configure {layers.length} Layers
                                        </h5>
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() => setShowLayers(false)}
                                        >
                                            Cancel
                                        </Button>
                                    </div>

                                    <Row>
                                        {layers.map((layer) => (
                                            <Col md="6" lg="4" key={layer.id} className="mb-3">
                                                <Card className="h-100 border-0 shadow-sm">
                                                    <Card.Header className="py-2" style={{ backgroundColor: themeLight }}>
                                                        <div className="d-flex align-items-center">
                                                            <div className="me-2" style={{
                                                                width: '24px',
                                                                height: '24px',
                                                                borderRadius: '50%',
                                                                backgroundColor: themeColor,
                                                                color: 'white',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                fontSize: '12px',
                                                                fontWeight: 'bold'
                                                            }}>
                                                                {` ${layer.id}`}
                                                            </div>

                                                        </div>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="small fw-bold text-muted">Number of Coils</Form.Label>
                                                            <Form.Control
                                                                type="number"
                                                                value={layer.coils}
                                                                onChange={(e) => updateLayerCoils(layer.id, e.target.value)}
                                                                min="0"
                                                                max="20"
                                                                style={{ borderColor: themeColor }}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group>
                                                            <Form.Label className="small fw-bold text-muted">Capacity per Coil</Form.Label>
                                                            <Form.Control
                                                                type="number"
                                                                value={layer.capacity}
                                                                onChange={(e) => updateLayerCapacity(layer.id, e.target.value)}
                                                                min="0"
                                                                max="50"
                                                                style={{ borderColor: themeColor }}
                                                            />
                                                        </Form.Group>
                                                    </Card.Body>
                                                    <Card.Footer className="bg-white border-0 pt-0">
                                                        <div className="text-center small text-muted">
                                                            Total Capacity: {layer.coils * layer.capacity} products
                                                        </div>
                                                    </Card.Footer>
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>

                                    <div className="text-center mt-4">
                                        <Button
                                            variant="primary"
                                            onClick={handleFinalCreate}
                                            className="px-5 py-2"
                                            style={{
                                                backgroundColor: themeColor,
                                                borderColor: themeColor
                                            }}
                                        >
                                            <Save size={18} className="me-2" />
                                            Finalize Configuration
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>



        </Container>
    );
}

export default Layers;